unit UClockInConfig;

interface

uses
  System.Classes;

type
  TClockInConfig = class
  private
    FList: TStringList;
    FUserInterface: Integer;
    procedure ClearValues;
    procedure SetValues(json: string);
    procedure SetList(const Value: TStringList);
    procedure SetUserInterface(const Value: Integer);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    property List: TStringList read FList write SetList;
    property UserInterface: Integer read FUserInterface write SetUserInterface;
  end;

implementation

uses
  Js, System.SysUtils;

{ TClockInConfig }

procedure TClockInConfig.ClearValues;
begin
  if Self.List = nil then
    Self.List := TStringList.Create
  else
    Self.List.Clear;
  Self.UserInterface := 1;
end;

constructor TClockInConfig.Create;
begin
  Self.ClearValues;
end;

constructor TClockInConfig.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TClockInConfig.SetList(const Value: TStringList);
begin
  FList := Value;
end;

procedure TClockInConfig.SetUserInterface(const Value: Integer);
begin
  FUserInterface := Value;
end;

procedure TClockInConfig.SetValues(json: string);
var
  obj: TJsObject;
  s: string;
  count, i: Integer;
begin
  Self.ClearValues;
  obj := TJsJson.parseObject(json);
  if obj['UserInterface'] <> nil then
    Self.UserInterface := StrToInt(string(obj['UserInterface']));
  if obj['List'] <> nil then
  begin
    s := string(obj['List']);
    obj := TJsJson.parseObject(s);
    if obj['Count'] <> nil then
    begin
      count := StrToInt(string(obj['Count']));
      for i := 0 to count - 1 do
        if obj['Item' + IntToStr(i)] <> nil then
          Self.List.Add(string(obj['Item' + IntToStr(i)]));
    end;
  end;
end;

end.
